"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionButtons = void 0;
var React = __importStar(require("react"));
var hooks_1 = require("../../common/hooks");
var components_1 = require("../../components");
/**
 * Maps "Actions" to actual buttons
 * @internal
 */
var ActionButtons = function (_a) {
    var actions = _a.actions;
    var isTabletSized = (0, hooks_1.useDeviceSizes)().isTabletSized;
    var primary = actions.primary;
    var populateCommonProps = function (a) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        var label = a.label, others = __rest(a, ["label"]);
        return __assign(__assign({}, others), { className: isTabletSized ? "mb-2 ml-0 w-100" : "mb-0 ml-2 w-auto", color: isTabletSized || a.outline ? "primary" : "link", outline: isTabletSized || a.outline });
    };
    var ActionButton = function (props) {
        var action = props.action, isPrimary = props.isPrimary;
        var commonProps = populateCommonProps(action);
        if (action.menuItems) {
            var menuItems = commonProps.menuItems, buttonProps = __rest(commonProps, ["menuItems"]);
            return (React.createElement(components_1.GKMenuButton, __assign({}, buttonProps, { color: isPrimary ? "primary" : commonProps.color, outline: isPrimary ? false : commonProps.outline, text: action.label, menuPlacement: action.menuPlacement || "top" }), menuItems));
        }
        else {
            // Deliberately destructuring so we can't pass menubutton props to button.
            /* eslint-disable @typescript-eslint/no-unused-vars */
            var closeOnSelect = commonProps.closeOnSelect, compact = commonProps.compact, containerClassName = commonProps.containerClassName, fullscreenCloseText = commonProps.fullscreenCloseText, menuPlacement = commonProps.menuPlacement, buttonProps = __rest(commonProps, ["closeOnSelect", "compact", "containerClassName", "fullscreenCloseText", "menuPlacement"]);
            /* eslint-enable @typescript-eslint/no-unused-vars */
            return (React.createElement(components_1.GKButton, __assign({}, buttonProps, { color: isPrimary ? "primary" : commonProps.color, outline: isPrimary ? false : commonProps.outline }), action.label));
        }
    };
    return (React.createElement(React.Fragment, null,
        actions.secondary
            .slice()
            .reverse()
            .map(function (action, i) { return (React.createElement(ActionButton, { action: action, key: i })); }),
        React.createElement(ActionButton, { action: primary, key: "primary", isPrimary: true })));
};
exports.ActionButtons = ActionButtons;
exports.default = exports.ActionButtons;
